var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantageGetYourScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.657 62.8308L44.9141 60.088L41.657 57.3451V62.8308Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.714 57.3451H13.0854V62.8308H41.714V57.3451Z",
    fill: "#183028"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.714 57.3451H13.0854V60.088H41.714V57.3451Z",
    fill: "#183028"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.657 61.1737L44.9141 60.088L43.657 59.0023V61.1737Z",
    fill: "#183028"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0856 57.3451H11.7712V62.8308H13.0856V57.3451Z",
    fill: "#F3BB90"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02832 60.088C9.02832 58.5451 9.77114 57.3451 10.6283 57.3451H11.714V62.8308H10.6283C9.77114 62.8308 9.02832 61.6308 9.02832 60.088Z",
    fill: "#F3BB90"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9997 23.7451V44.7166C57.9997 47.5166 55.714 49.8023 52.914 49.8023H22.2854L16.3426 55.7451C15.5426 56.5451 14.2283 55.9737 14.2283 54.888V49.8594C11.4283 49.8594 9.14258 47.5737 9.14258 44.7737V23.8023C9.14258 21.0023 11.4283 18.7166 14.2283 18.7166H52.914C55.6569 18.6594 57.9997 20.9451 57.9997 23.7451Z",
    fill: "#E87722"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7427 24.6023C22.7427 24.3737 22.9141 24.2023 23.1426 24.2023H51.8855C52.1141 24.2023 52.2855 24.3737 52.2855 24.6023C52.2855 24.8308 52.1141 25.0023 51.8855 25.0023H23.1426C22.9141 25.0023 22.7427 24.8308 22.7427 24.6023Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7427 31.7451C22.7427 31.5166 22.9141 31.3451 23.1426 31.3451H51.8855C52.1141 31.3451 52.2855 31.5166 52.2855 31.7451C52.2855 31.9737 52.1141 32.1451 51.8855 32.1451H23.1426C22.9141 32.1451 22.7427 31.9737 22.7427 31.7451Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7427 39.288C22.7427 39.0594 22.9141 38.888 23.1426 38.888H51.8855C52.1141 38.888 52.2855 39.0594 52.2855 39.288C52.2855 39.5165 52.1141 39.688 51.8855 39.688H23.1426C22.9141 39.7451 22.7427 39.5165 22.7427 39.288Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3998 23.1165H15.5426C15.1998 23.1165 14.9141 23.4023 14.9141 23.7451V24.6023C14.9141 24.9451 15.1998 25.2308 15.5426 25.2308H16.3998C16.7426 25.2308 17.0284 24.9451 17.0284 24.6023V23.7451C16.9712 23.4023 16.7426 23.1165 16.3998 23.1165Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3998 30.6594H15.5426C15.1998 30.6594 14.9141 30.9451 14.9141 31.288V32.1451C14.9141 32.488 15.1998 32.7737 15.5426 32.7737H16.3998C16.7426 32.7737 17.0284 32.488 17.0284 32.1451V31.288C16.9712 30.9451 16.7426 30.6594 16.3998 30.6594Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3998 38.2594H15.5426C15.1998 38.2594 14.9141 38.5451 14.9141 38.888V39.7451C14.9141 40.088 15.1998 40.3737 15.5426 40.3737H16.3998C16.7426 40.3737 17.0284 40.088 17.0284 39.7451V38.888C16.9712 38.5451 16.7426 38.2594 16.3998 38.2594Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9426 36.8308V49.8594H70.9712C71.0283 42.6594 65.1998 36.8308 57.9426 36.8308Z",
    fill: "#E87722"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9427 49.8594V36.8308C50.7427 36.8308 44.9141 42.6594 44.9141 49.8594C44.9141 57.0594 50.7427 62.888 57.9427 62.888C61.5427 62.888 64.7998 61.4023 67.1426 59.0594L57.9427 49.8594Z",
    fill: "#F3BB90"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9426 49.8594L67.1426 59.0594C69.4855 56.7165 70.9712 53.4594 70.9712 49.8594H57.9426Z",
    fill: "#E87722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantageGetYourScore);
export default __webpack_public_path__ + "static/media/advantage_getYourScore.403a3a01509f757683b27816bf1a6283.svg";
export { ForwardRef as ReactComponent };